import { Card, CardBody, CardHeader } from '@nextui-org/react'
import { FC } from 'react'
import { useTankInfoModalStore } from '../../../store/tankInfo/useTankInfoModalStore'
import { CardNameLiteral, GraphSetting } from '../../../types/apiResponse/tankInfoSettingTypes'
import { getCardValue } from '../../../types/mappers/tankInfo.mapper'
import { convertMetric } from '../../../utils/metricConvert'
import { makeTitle } from '../../../utils/tankInfo'
import { NoContent } from './NoContent'

export type GraphProps = {
  tankId: string
  cardName: CardNameLiteral
  graphSetting: GraphSetting
}

export const GraphCard: FC<GraphProps> = ({ tankId, cardName, graphSetting }) => {
  const cardValues = useTankInfoModalStore((state) => state.cardValues)

  // Store에서 이미 계산된 카드 값 사용
  const curValue = cardValues ? getCardValue(cardValues, cardName as any) : undefined
  const { val, metric } = convertMetric(curValue, cardName, graphSetting?.metric ?? '')

  const { title, subTitle } = makeTitle(cardName)

  return (
    <Card
      className="
        rounded-lg col-span-1
        border border-tdpldarkgrey/60
        w-full md:w-auto
        h-[140px] md:h-[8.75rem]
        p-4 md:p-5
        shadow-card
        bg-tdplbisque
      "
      data-card-type="graph"
      data-testid={`graph-card-${cardName}`}
    >
      <CardHeader className="flex flex-row items-start gap-2 p-0 mb-4 min-h-[1.375rem]">
        <p className="text-base font-bold text-tdpldarkgrey">{title}</p>
        {subTitle && <p className="text-base text-tdplmiddlegrey">{subTitle}</p>}
      </CardHeader>

      <CardBody className="p-0 overflow-visible">
        {val === '---' || curValue === undefined || curValue === null ? (
          <NoContent />
        ) : (
          <div className="flex flex-row justify-between items-center gap-4 min-h-[4rem]">
            {/* Value Display */}
            <div className="flex flex-col items-start flex-1">
              <p className="text-base md:text-xl font-bold text-tdplprussian leading-tight">
                {val}
              </p>
              <p className="text-sm text-tdplprussian">{graphSetting?.metric ? metric : null}</p>
            </div>
          </div>
        )}
      </CardBody>
    </Card>
  )
}
